import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import PrintIcon from "@mui/icons-material/Print";
import LoadingButton from "@mui/lab/LoadingButton";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormLabel from "@mui/material/FormLabel";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { BlobProvider } from "@react-pdf/renderer";
import React, { useEffect, useState } from "react";
import PrintStrukKesimpulan from "../../components/PrintStrukKesimpulan/PrintStrukKesimpulan";
import useKesimpulan from "../../services/queries/useKesimpulan";

import DatePicker from "react-datepicker";
import {
    ContentUkm,
    ParamsKesimpulan,
    UserResponse,
} from "../../constants/types";
import { useAuth } from "../../context/authContext";
import useShiftNow from "../../services/queries/useShiftNow";

interface IModalPrintTutupBukuProps {
    user?: UserResponse["data"];
    ukmData?: ContentUkm;
    nowK: string;
    open: boolean;
    onClose: () => void;
}

const ModalPrintTutupBuku = ({
    user,
    ukmData,
    nowK,
    open,
    onClose,
}: IModalPrintTutupBukuProps) => {
    const moment = require("moment");
    let now = moment().format("YYYY/MM/DD");
    const { ukmIdUser } = useAuth();

    const theme = useTheme();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.down("md"));
    const isTabletScreen = useMediaQuery(theme.breakpoints.between("sm", "md"));

    const [state, setState] = useState({
        isBarangTerjual: false,
    });

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setState({
            ...state,
            [event.target.name]: event.target.checked,
        });
    };

    useEffect(() => {
        if (ukmData?.webBarangTerjualTutupBuku === 1) {
            setState((prev) => ({
                ...prev,
                isBarangTerjual: true,
            }));
        }
    }, [ukmData]);

    const initialParamsKesimpulan = {
        ukmId: undefined,
        tanggal: now,
        grupProduk: 1,
        isShift: 1,
    };
    const [paramsKesimpulan, setParamsKesimpulan] = useState<ParamsKesimpulan>(
        initialParamsKesimpulan,
    );
    const { data: kesimpulan } = useKesimpulan(paramsKesimpulan);

    const { data: shiftNow } = useShiftNow({
        ukmId: ukmIdUser && ukmIdUser[0],
        tipe: "now",
    });

    useEffect(() => {
        if (ukmIdUser) {
            setParamsKesimpulan((prev) => ({
                ...prev,
                ukmId: ukmIdUser && ukmIdUser[0],
            }));
        }
    }, [ukmIdUser]);

    useEffect(() => {
        if (shiftNow?.id) {
            setParamsKesimpulan((prev) => ({
                ...prev,
                shiftId: shiftNow?.id,
            }));
        }
    }, [shiftNow]);

    return (
        <Dialog
            maxWidth="sm"
            fullScreen={isPhoneScreen}
            fullWidth
            open={open}
            onClose={onClose}
            scroll="body"
            PaperProps={{
                sx: {
                    borderRadius: 1,
                },
            }}
        >
            <DialogTitle>
                <Stack direction="row" spacing={1} alignItems="center">
                    <IconButton onClick={onClose}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" fontWeight="bold">
                        Print Tutup Buku
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Stack mb={18}>
                    <Stack mb={2}>
                        <Typography mb={1}>Pilih tanggal</Typography>
                        <DatePicker
                            className="range-filter"
                            dateFormat="dd/MM/yyyy"
                            disabledKeyboardNavigation
                            onFocus={(e) => e.target.blur()}
                            selected={moment(paramsKesimpulan.tanggal).toDate()}
                            onChange={(update) => {
                                if (update) {
                                    setParamsKesimpulan((prev) => ({
                                        ...prev,
                                        tanggal:
                                            moment(update).format("YYYY/MM/DD"),
                                    }));
                                }
                            }}
                            // minDate={now}
                            monthsShown={1}
                            customInput={
                                <FormControl fullWidth>
                                    <Stack
                                        display="flex"
                                        justifyContent="space-between"
                                        direction="row"
                                        // width="100%"
                                        bgcolor="#FFFF"
                                        height="40px"
                                        sx={{
                                            border: "1px solid #cbcbcb",
                                            borderRadius: "4px",
                                            alignItems: "center",
                                            padding: 2,
                                            cursor: "pointer",
                                        }}
                                    >
                                        <Typography
                                            color={
                                                paramsKesimpulan.tanggal
                                                    ? undefined
                                                    : "#cbcbcb"
                                            }
                                        >
                                            {paramsKesimpulan.tanggal
                                                ? paramsKesimpulan.tanggal
                                                      .split("/")
                                                      .reverse()
                                                      .join("/")
                                                : "Pilih tanggal"}
                                        </Typography>
                                        <ArrowDropDown
                                            sx={{
                                                marginRight: "-9px",
                                            }}
                                        />
                                    </Stack>
                                </FormControl>
                            }
                        />
                    </Stack>
                    <FormControl
                        sx={{ px: 1 }}
                        component="fieldset"
                        variant="standard"
                    >
                        <FormLabel component="legend">
                            Pilih apakah ingin menyertakan "Barang Terjual"
                            dalam print:
                        </FormLabel>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={state.isBarangTerjual}
                                        onChange={handleChange}
                                        name="isBarangTerjual"
                                    />
                                }
                                label="Sertakan Barang Terjual"
                            />
                        </FormGroup>
                    </FormControl>
                </Stack>
            </DialogContent>
            <DialogActions sx={{ padding: 2 }}>
                <BlobProvider
                    document={
                        <PrintStrukKesimpulan
                            namaToko={shiftNow?.kantungParkir.nama ?? "Toko"}
                            alamatToko={ukmData?.alamatToko ?? "Toko"}
                            telpToko={ukmData?.noTelp ?? "Toko"}
                            gambarToko={
                                ukmData?.gambarTokoBW === null
                                    ? undefined
                                    : ukmData?.gambarTokoBW
                            }
                            tanggalTransaksi={moment(
                                paramsKesimpulan.tanggal,
                            ).format("DD MMMM YYYY")}
                            html={undefined}
                            kesimpulan={kesimpulan ?? []}
                            isBarangTerjual={state.isBarangTerjual}
                        />
                    }
                >
                    {({ blob, url, loading, error }) => {
                        return (
                            <LoadingButton
                                disabled={
                                    user && !user.akses.laporan.includes(36)
                                }
                                loading={loading}
                                startIcon={
                                    isPhoneScreen ||
                                    isTabletScreen ? undefined : (
                                        <PrintIcon />
                                    )
                                }
                                loadingPosition="center"
                                size="small"
                                variant="contained"
                                href={url ?? ""}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {/* Print Tutup Buku */}
                                {isPhoneScreen || isTabletScreen ? (
                                    <PrintIcon />
                                ) : (
                                    "Print Tutup Buku"
                                )}
                            </LoadingButton>
                        );
                    }}
                </BlobProvider>
            </DialogActions>
        </Dialog>
    );
};

export default ModalPrintTutupBuku;
